import styled, { css } from 'styled-components';

import { media, Table } from '@minerva-analytics/pantheon';
import { BLUE, MEDIUM_GRAY } from 'root/theme';


const Row = styled.tr`
  ${(props) => props.bolded
    ? css`
      font-weight: bold;
      color: ${BLUE};
    `
    : ``}

  ${media.phone`
    padding: 0.5rem 0.75rem;
  `}
`;

const Container = styled.div`
  color: ${MEDIUM_GRAY};
`;

const THeader = styled.thead`
  font-size: 0.825rem;
  /* Hide table headers (but not display: none;, for accessibility) */
  ${media.phone`
    position: absolute;
    top: -9999px;
    left: -9999px;
  `}
`;

const StyledTD = styled.td`
  font-size: 0.825rem;
  ${(props) => props.breakWord || css`word-wrap: break-word;`}
  ${media.tablet`
    font-size: 0.75rem;
  `}

  ${media.phone`
    &::before {
      position: absolute;
      top: 0.25rem;
      left: 0;
      width: 20%;
      padding-right: 10px;
      white-space: nowrap;
    }

    &:nth-of-type(1):before { content: "Rank:"; }
    &:nth-of-type(2):before { content: "Username:"; }
    &:nth-of-type(3):before { content: "Percent:"; }
    &:nth-of-type(4):before { content: "Score:"; }
  `}
`;

const Body = styled.tbody`
`;

const StyledTH = styled.th`
`;

const StyledTable = styled(Table)`
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    ${media.phone`
      display: block;
    `}
  }

  td {
    ${media.phone`
      border: none;
      position: relative;
      padding-left: 100px;
      padding-top: 0.1rem;
      padding-bottom: 0.1rem;
    `}
  }

  td:first-child {
    ${media.phone`
      padding-left: 100px;
    `}
  }


`;

export {
  Row,
  THeader,
  Body,
  Container,
  StyledTD,
  StyledTH,
  StyledTable,
};
